import { observable } from 'mobx';

import { autobind } from 'core-decorators';
import { useEffect } from 'react';

class CountDownStore {
  /**
   * 年
   * @type {string}
   */
  @observable years = '- -';
  /**
   * 天
   * @type {string}
   */
  @observable days = '- - -';
  /**
   * 小时
   * @type {string}
   */
  @observable hours = '- -';
  /**
   * 分钟
   * @type {string}
   */
  @observable minutes = '--';
  /**
   * 秒数
   * @type {string}
   */
  @observable seconds = '--';

  /**
   * 是否开始倒计时
   * @type {boolean}
   */
  @observable isStart = false;
  /**
   * 倒计时速率
   * @type {number}
   */
  @observable countdownMultiplier = 1;

  /**
   * 总秒数
   * @type {number}
   */
  @observable totalSeconds = undefined;

  /**
   * 是否已经有动效
   * @type {boolean}
   */
  @observable hasAnimation = false;
  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  /**
   * 补0
   * @param unit
   * @returns {string}
   */
  formatTimeUnit(unit) {
    return String(unit).padStart(2, '0');
  }

  /**
   * 倒计时核心逻辑
   * @param totalSeconds
   * @param timeMultiplier
   */
  @autobind
  startCountdown(totalSeconds, timeMultiplier) {
    let remainingSeconds = totalSeconds;

    // 根据倍率计算更新的间隔时间
    const updateInterval = 1000 * timeMultiplier;

    this.countdownInterval = setInterval(() => {
      // 计算年、天、小时、分钟、秒
      const secondsInMinute = 60;
      const secondsInHour = 60 * secondsInMinute;
      const secondsInDay = 24 * secondsInHour;
      const secondsInYear = 365 * secondsInDay;

      const years = Math.floor(remainingSeconds / secondsInYear);
      const days = Math.floor((remainingSeconds % secondsInYear) / secondsInDay);
      const hours = Math.floor((remainingSeconds % secondsInDay) / secondsInHour);
      const minutes = Math.floor((remainingSeconds % secondsInHour) / secondsInMinute);
      const seconds = Math.floor(remainingSeconds % secondsInMinute);
      this.years = this.formatTimeUnit(years);
      this.days = this.formatTimeUnit(days);
      this.hours = this.formatTimeUnit(hours);
      this.minutes = this.formatTimeUnit(minutes);
      this.seconds = this.formatTimeUnit(seconds);
      // 显示倒计时
      // console.log(`倒计时: ${years}年 ${days}天 ${hours}小时 ${minutes}分钟 ${seconds}秒`);

      // 每次减去 1 秒
      remainingSeconds -= 1;

      // 倒计时结束条件
      if (remainingSeconds <= 0) {
        clearInterval(this.countdownInterval);
        this.seconds = this.formatTimeUnit(0);
        console.log('倒计时结束！');
      }
    }, updateInterval);
  }

  /**
   * 开始倒计时
   */
  @autobind
  run(magnification) {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    // 30年 - 946080000s 一天 - 86400s
    const totalSeconds = this.totalSeconds; // 传入总秒数
    // const timeMultiplier = 1 / this.countdownMultiplier; // 时间倍率
    const timeMultiplier = 1 / magnification; // 时间倍率
    if (!this.isStart) {
      let remainingSeconds = totalSeconds;

      const secondsInMinute = 60;
      const secondsInHour = 60 * secondsInMinute;
      const secondsInDay = 24 * secondsInHour;
      const secondsInYear = 365 * secondsInDay;

      const years = Math.floor(remainingSeconds / secondsInYear);
      const days = Math.floor((remainingSeconds % secondsInYear) / secondsInDay);
      const hours = Math.floor((remainingSeconds % secondsInDay) / secondsInHour);
      const minutes = Math.floor((remainingSeconds % secondsInHour) / secondsInMinute);
      const seconds = Math.floor(remainingSeconds % secondsInMinute);
      this.years = this.formatTimeUnit(years);
      this.days = this.formatTimeUnit(days);
      this.hours = this.formatTimeUnit(hours);
      this.minutes = this.formatTimeUnit(minutes);
      this.seconds = this.formatTimeUnit(seconds);
      return;
    }
    this.startCountdown(totalSeconds, timeMultiplier);
  }

  /**
   * 开始动画
   */
  @autobind
  startAnimation() {
    this.hasAnimation = true;
    setTimeout(() => {
      this.hasAnimation = false;
    }, 4000);
  }
  use() {
    useEffect(
      () => {
        if (this.totalSeconds && this.countdownMultiplier) {
          this.run(this.countdownMultiplier);
        }
      },
      [this.totalSeconds, this.countdownMultiplier, this.isStart]
    );
    // useMount(() => {
    //   const $ = window.$;
    //   setTimeout(() => {
    //     this.hasAnimation = true;
    //   }, 5000);
    //   setTimeout(() => {
    //     this.hasAnimation = false;
    //   }, 8000);
    // });
  }
}

export default CountDownStore;
